// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 413) return "content/plugin-alerts-dashboard-channels/368b248c4bb6c9cc27b25cb235c0cd96.js";
	if (chunkId === 939) return "content/plugin-alerts-dashboard-channels/392c57657e3b7edc962059d028e2ec3b.js";
	if (chunkId === 561) return "content/plugin-alerts-dashboard-channels/aace8d895bb22944e33ac560a37d3553.js";
	if (chunkId === 626) return "content/plugin-alerts-dashboard-channels/81dd4ee446914cffc7193470df4e806a.js";
	if (chunkId === 989) return "content/plugin-alerts-dashboard-channels/e1e2b4235e52b931cc743ac78e85cb85.js";
	if (chunkId === 276) return "content/plugin-alerts-dashboard-channels/9599e4da1aa27d2b8246ac09bf8ed90d.js";
	// return url for filenames based on template
	return undefined;
};